// const isDebug = false
import axios from 'axios'
import Apis from './api'
import { getAuthHeaders, signOut } from '@/utils/session'

const legoClient = axios.create({
  baseURL: Apis.baseUrl,
  headers: {},
  timeout: 1000 * 60 * 10,
})

legoClient.interceptors.request.use(
  (config: any) => {
    config.headers = {
      ...config.headers,
      ...getAuthHeaders(),
    }
    return config
  },
  (error: any) => {
    return error
  }
)

// 添加响应拦截器
legoClient.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response?.status === 401) {
      signOut()
    }
    return Promise.reject(error)
  }
)

export default legoClient
